import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import config from "@/config";

Vue.use(Vuex);

const Organization = {
    namespaced: true,
    state: {
        orgData: null,
    },
    getters: {
        orgData: state => state.orgData || {},
    },
    mutations: {
        SET_ORG(state, data) {
            state.orgData = data;
        },
        SET_LOGO(state, logo) {
            state.orgData.logo = logo;
        }
    },
    actions: {
        getMyOrg({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(config.API_URL + '/organization')
                    .then(response => {
                        commit("SET_ORG", response.data.data);
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    })
            })
        },
        updateMyOrg({ state, commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(config.API_URL + '/organization', { ...state.orgData })
                    .then(response => {
                        commit("SET_ORG", response.data.data);
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    })
            })
        }
    }
}

export default Organization;